var React = require('react');

function DesktopIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#fff","strokeWidth":"2","d":"M6 6h36v27H6z","key":0}),React.createElement("path",{"fill":"#fff","d":"M16 40h16v3H16zM23 33h2v5h-2zM33.414 11a1 1 0 0 0-.707.293l-1.121 1.121a2 2 0 0 1-1.414.586H23.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h2.086a1 1 0 0 0 .707-.293l1.121-1.121A2 2 0 0 1 28.828 23H35.5a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5h-2.086z","key":1})]);
}

DesktopIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = DesktopIcon;

DesktopIcon.default = DesktopIcon;
